import * as BreakUpText from '../utilities/BreakUpText';
import * as CoreFns from '../utilities/CoreFns';
import * as EditorFunctions from '../utilities/EditorFunctions';
import * as SearchForAnEntityWithPath from '../utilities/SearchForAnEntityWithPath';
import * as ResponsiveFns from '../utilities/ResponsiveFns';

export function clickFeOrPu(item, asChanges, isFEOrPU, handleChanges, userNos, currentList){

      var pathDown = [isFEOrPU];
      var uuid = CoreFns.uuidScoped(userNos, currentList, pathDown, []);  
      BreakUpText.searchPage(item);
      item.n = CoreFns.simplName(uuid);
      var ord = ResponsiveFns.getNextOrdDirect(currentList, pathDown);
      item.ord = ord;

      var maxPositionX = ResponsiveFns.getMaxPosition(currentList);

      item.pos = {xP:maxPositionX, yP:0};

      var changes = [{t:'w',w:pathDown.concat([uuid]),n:item}].concat(asChanges);
      handleChanges(uuid, changes, '1');
  
}
export function clickItem(itemSet, currentList, itemT, doingWhat, setDoingWhat, addPath, chains, setIsClickingOnContentDiv, userNos, organicChanges, setItemEdited, changeTab, setIsShowingSomeDropDown, hidePanelRelativeItems, setHidePanelRelativeItems, position, insetWidth, insetHeight, refObject){

    var itemX = itemSet.v;
    var item = JSON.parse(JSON.stringify(itemX));
    BreakUpText.getText(itemT, item);
    var currentListX = JSON.parse(JSON.stringify(currentList));
    currentListX.as = JSON.parse(JSON.stringify(itemSet.as));


    if (itemT === 'ALERT'){
        var id5 = CoreFns.uuidCheckEverywhere(userNos, currentList);
        var path = addPath.concat([id5]);
        EditorFunctions.doASetOfUploadOrDownloadTemplateModifiers(item, itemT, path, 'elementDownloadMods', currentListX, chains, changeTab);
        var asChanges4 = SearchForAnEntityWithPath.getASChanges(itemSet, itemT, currentListX, userNos);
        item._na = id5.substr(id5.length - 3);
        var ord1 = ResponsiveFns.getNextOrd(currentList, addPath);
        item.s.ord = {t:'int', v:ord1};
        organicChanges([{t:'w',w:path,n:item}].concat(asChanges4));
        setItemEdited({t:'alert', path});
        if (ord1 > 0){
          setIsShowingSomeDropDown({t:'itemPosition'});
        }
        var screenPart = CoreFns.filterPathStopBefore(addPath, 4);
        delete hidePanelRelativeItems[screenPart.join(' ')];
        setHidePanelRelativeItems({...hidePanelRelativeItems});
    }else if (itemT === 'PANEL'){

      var screens = CoreFns.goDownPath(currentList, addPath);
      var screenKeys = CoreFns.sortedKeyList(screens);
      // backgroundColor:{t:'raw',v:'rgb(255, 255, 255)'}}
      var ord = 0;
      if (screenKeys.length > 0){
        var lastScreen = screens[screenKeys[screenKeys.length - 1]];
        ord = lastScreen.ord + 1;
      }
      item.ord = ord;
      var uuid = CoreFns.uuidScoped(userNos, currentList, addPath, []);  
      item._na = CoreFns.simplName(uuid);
      EditorFunctions.doASetOfUploadOrDownloadTemplateModifiers(item, itemT, addPath.concat([uuid]), 'elementDownloadMods', currentListX, chains, changeTab);
      var asChanges5 = SearchForAnEntityWithPath.getASChanges({v:item, as:currentListX.as}, itemT, currentListX, userNos);
      var changes = [{t:'w',w:addPath.concat([uuid]),n:item}].concat(asChanges5);
      organicChanges(changes);
      setItemEdited({t:'screen', path:addPath.concat([uuid])});
      if (doingWhat && doingWhat.t === 'guide' && doingWhat.v === 0){
        setDoingWhat({t:'guide',v:1});
      }
      if (ord > 0){
        setIsShowingSomeDropDown({t:'screenPosition'});
      }
    }else if (itemT === 'FOOTER'){
      EditorFunctions.doASetOfUploadOrDownloadTemplateModifiers(item, itemT, ['fo'], 'elementDownloadMods', currentListX, chains, changeTab);
      var asChanges6 = SearchForAnEntityWithPath.getASChanges(itemSet, itemT, currentListX, userNos);
      organicChanges([{t:'w',w:['fo'],n:item}].concat(asChanges6));
      setItemEdited({t:'screen', path:['fo']});
    }else if (itemT === 'navBar'){
      if (item.origRef){
        organicChanges([{t:'w', w:addPath, n:{on:item.origRef}}]);
      }else{
        EditorFunctions.doASetOfUploadOrDownloadTemplateModifiers(item, itemT, addPath, 'elementDownloadMods', currentListX, chains, changeTab);
        var asChanges7 = SearchForAnEntityWithPath.getASChanges(itemSet, itemT, currentListX, userNos);
        var uuid2 = CoreFns.uuidScoped(userNos, currentList, ['cn'], []);  
        delete item.on;
        var newNav = {nv:item, n:CoreFns.simplName(uuid2), ord:0};
        var set = [{t:'w', w:['cn', uuid2], n:newNav}].concat(asChanges7).concat([{t:'w',w:addPath,n:{on:uuid2}}]);
        organicChanges(set);
      }
      setItemEdited({t:'navBar', path:addPath})
    }else{
      if (itemT === 'BUTTON'){
        if (doingWhat && doingWhat.t === 'guide' && doingWhat.v === 3){
          setDoingWhat({t:'guide',v:4});
        }
      }else if (itemT === 'HFLEX'){
        if (doingWhat && doingWhat.t === 'guide' && doingWhat.v === 2){
          setDoingWhat({t:'guide',v:3});
        }
      }else if (itemT === 'CONTAINER'){
        if (doingWhat && doingWhat.t === 'guide' && doingWhat.v === 1){
          setDoingWhat({t:'guide',v:2});
        }
      }
      var uuid3 = CoreFns.uuidCheckEverywhere(userNos, currentList);
      EditorFunctions.doASetOfUploadOrDownloadTemplateModifiers(item, itemT, addPath.concat([uuid3]), 'elementDownloadMods', currentListX, chains, changeTab);
      var asChanges3 = SearchForAnEntityWithPath.getASChanges(itemSet, itemT, currentListX, userNos);
      var pathOut = ResponsiveFns.reallyAddItem(item, addPath, uuid3, position, currentListX, organicChanges, asChanges3, setItemEdited, insetWidth, insetHeight, setIsShowingSomeDropDown, hidePanelRelativeItems, setHidePanelRelativeItems);        

      if (itemT === 'DIV'){
        setTimeout(function(){ 
          var refHere = refObject[pathOut.join('_')];
          if (refHere){
            refHere.current.focus();
          }
          setIsClickingOnContentDiv(true);

        }, 10);

      }




    }
    

  }
